import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { t } from '../i18n';

const NotFound = () => {
  const { isAuthenticated } = useSelector(state => state.auth);
  const primaryLink = isAuthenticated
    ? { to: '/dashboard', label: t('ui.notFound.goDashboard') }
    : { to: '/login', label: t('ui.notFound.goLogin') };

  return (
    <div className="container d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
      <h1 className="display-4 mb-3">404</h1>
      <p className="lead mb-4">{t('ui.notFound.title')}</p>
      <div className="d-flex gap-2">
        <Link className="btn btn-primary" to={primaryLink.to}>{primaryLink.label}</Link>
        <Link className="btn btn-outline-secondary" to="/">{t('ui.notFound.backHome')}</Link>
      </div>
    </div>
  );
};

export default NotFound;


